// extracted by mini-css-extract-plugin
export default {"desktop":"desktop","container":"dnK4ZWMg","mobile":"mobile","content":"moeie6aO","button":"lgW1FWkb","buttonLink":"JInuP8U3","buttonText":"_W9TEC3F"};